import { Injectable, signal } from '@angular/core';
import { userDtos } from '@vectronic/openApi-customer';

@Injectable({ providedIn: 'root' })
export class GroupSelectionService {
  selectedGroup = signal<userDtos.Group | undefined>(undefined);

  selectGroup(group: userDtos.Group) {
    this.selectedGroup.set({ ...group });
  }

  updateGroup(group: userDtos.Group) {
    if (JSON.stringify(group) !== JSON.stringify(this.selectedGroup()))
      this.selectedGroup.set({ ...group });
  }

  isSelected(id: number) {
    return this.selectedGroup()?.id === id;
  }
}
